import { render } from "./LeadSection.vue?vue&type=template&id=f65fe61c&scoped=true"
import script from "./LeadSection.vue?vue&type=script&lang=js"
export * from "./LeadSection.vue?vue&type=script&lang=js"

import "./LeadSection.vue?vue&type=style&index=0&id=f65fe61c&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65fe61c"]])

export default __exports__